const loginHelpResetCreatePassword = `
    <pwr-reset-password-create-password>
    </pwr-reset-password-create-password>`;
export default loginHelpResetCreatePassword;
